import React from "react";
import Skeleton from 'react-loading-skeleton'
import CardLoader from './CardLoader.js';

const BlockLoader = ({ groupNumber, cardNumber }) => (
  Array(groupNumber).fill().map((item, index) => (
    <section key={`group_${index}`} className="block-views contextual-region block-views-blockwinner-in-category-block-1">
      <div className="container card-container view-winner-in-category">
        <h2 className=""><Skeleton width={250} /></h2>
        <div className="view-content">
          <CardLoader cardNumber={cardNumber} />
        </div>
      </div>
    </section>
  ))
)

export default BlockLoader;